// Soft onboarding nudge. Reads required-learning status from the shared
// store (polled once per navigation by MandatoryLearningGate) and, if the
// user has incomplete mandatory items, shows a non-blocking prompt with a
// CTA to Learning.
//
// For NON-admins the hard gate (MandatoryLearningGate) already redirects
// them into Learning — where this banner self-hides — so in practice this
// is the nudge ADMINS see (they're exempt from the redirect but may still
// have required training). Rendered globally from App.tsx.
import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { GraduationCap, X } from 'lucide-react'
import { useMandatoryLearningStore } from '../stores/mandatoryLearningStore'

export default function RequiredLearningGate() {
  const navigate = useNavigate()
  const location = useLocation()
  const items = useMandatoryLearningStore((s) => s.items)
  const [dismissed, setDismissed] = useState(false)

  // Don't nag while the user is already in Learning, or after dismiss.
  const onLearning = location.pathname.startsWith('/workspace/learning')
  if (dismissed || onLearning || items.length === 0) return null

  return (
    <div className="fixed bottom-4 right-4 z-[60] w-80 bg-card ring-1 ring-amber-500/40 rounded-xl shadow-lg p-4">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-amber-500/15 flex items-center justify-center shrink-0">
          <GraduationCap size={18} className="text-amber-400" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-foreground">Required training</div>
          <p className="text-xs text-muted-foreground mt-0.5">
            Complete {items.length}{' '}
            {items.length === 1 ? 'required item' : 'required items'} to start working.
          </p>
        </div>
        <button onClick={() => setDismissed(true)} title="Dismiss" className="text-muted-foreground hover:text-foreground shrink-0">
          <X size={15} />
        </button>
      </div>
      <button
        onClick={() => navigate('/workspace/learning')}
        className="mt-3 w-full text-sm font-medium px-3 py-2 rounded-lg bg-primary text-primary-foreground hover:opacity-90 transition"
      >
        Go to training
      </button>
    </div>
  )
}
